import React from 'react'
import { PageBlock } from './types'
import { GatsbyImage } from 'gatsby-plugin-image';

// @ts-expect-error
import { benefitsContainer, benefitsIcon, benefitsIconWrapper, benefitsIconsContainer, hpSectionHeading } from './index.module.scss';
import { useMediaQuery } from '@material-ui/core';
import { MOBILE_BREAKPOINT } from '../../utils/constants';

const Benefits = ({ data }: { data: PageBlock }) => {
  const { title, subtitle, benefitCards } = data;
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const iconColumns = isMobile ? 2 : 4;

  return (
    <>
      <div className={benefitsContainer}>
        <h3 className={`${hpSectionHeading}`}>{title}</h3>
        <p>{subtitle}</p>
      </div>
      <div className={`${benefitsIconsContainer}`} style={{ gridTemplateColumns: `repeat(${iconColumns}, 1fr)` }}>
        {benefitCards?.map(card => {
          return (
            <div className={`${benefitsIconWrapper}`} key={card._key}>
              <GatsbyImage
                image={card.image.asset.gatsbyImageData}
                className={`${benefitsIcon}`}
                alt={card.title || ''} />
              <h4>{card.title}</h4>
              <p>{card.description}</p>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default Benefits
